import { useSearchParams } from 'react-router-dom';
import { credentials } from '../lib/api';
import { useApi } from '../hooks/useApi';
import { useTranslation, type TKey } from '../i18n';

export default function VerifyPage() {
  const { t } = useTranslation();
  const [sp] = useSearchParams();
  const urn = sp.get('urn') ?? '';
  const state = useApi(() => credentials.verify(urn), [urn]);
  const r = state.status === 'success' ? state.data : null;
  const verdict: 'valid' | 'invalid' | 'notFound' | null =
    !r ? null : !r.found ? 'notFound' : r.valid ? 'valid' : 'invalid';

  return (
    <main className="container verify-page">
      <h1 className="verify-title">{t('verify.title')}</h1>

      {state.status === 'loading' && <p className="verify-checking">{t('verify.checking')}</p>}

      {verdict && (
        <div className={`verify-card verify-card--${verdict}`}>
          <div className="verify-icon" aria-hidden="true">
            {verdict === 'valid' ? '✓' : verdict === 'invalid' ? '✗' : '?'}
          </div>
          <p className="verify-verdict">{t(`verify.${verdict}` as TKey)}</p>
          {r?.found && (
            <dl className="verify-meta">
              <div><dt>{t('verify.tier')}</dt><dd>{r.tier ?? '—'}</dd></div>
              <div><dt>{t('verify.issued')}</dt><dd>{r.issued_at ? r.issued_at.slice(0, 10) : '—'}</dd></div>
            </dl>
          )}
        </div>
      )}

      <p className="verify-note">{t('verify.note')}</p>
    </main>
  );
}
